export const environment = {
  production: true,
  buildId: '3308947622721471',
  configFile: 'config.json',
};
